export const fr = {
    EngagementMetricPicker: {
        ariaLabel: "Métrique : {{label}}"
    },
    MetricTrendChart: {
        title: "{{metric}} au fil du temps",
        legend: {
            yourTeam: "Votre équipe",
            company: "Entreprise"
        },
        delta_one: "{{sign}}{{value}} pt",
        delta_other: "{{sign}}{{value}} pts",
        deltaZero: "Aucun changement",
        yAxisLabel: "Score",
        ariaLabel: "Score de {{metric}} sur les {{period}}."
    },
    SubMetricsList: {
        eyebrow: "Sous-métriques",
        tooltipLabel: "À propos de {{subMetric}}",
        delta_one: "{{sign}}{{value}} pt",
        delta_other: "{{sign}}{{value}} pts",
        deltaZero: "Aucun changement"
    },
    QuestionsDistributionTable: {
        title: "Questions de {{metric}}",
        caption: "Questions pulse du facteur {{metric}}, avec la distribution des réponses de l'équipe.",
        columns: {
            subMetric: "Sous-métrique",
            question: "Question",
            results: "Résultats"
        },
        band: {
            stronglyAgree: "Très favorable",
            agree: "Favorable",
            neutral: "Neutre",
            disagree: "Défavorable",
            stronglyDisagree: "Très défavorable"
        },
        noResponses: "Pas assez de réponses pour l'instant",
        writtenResponses_one: "{{count}} réponse écrite",
        writtenResponses_other: "{{count}} réponses écrites",
        partialSample: "Résultats basés sur un échantillon partiel",
        extensiveSample: "Résultats basés sur un échantillon étendu",
        resultsAriaLabel: "Résultats pour « {{question}} » : Très favorable {{stronglyAgree}} %, Favorable {{agree}} %, Neutre {{neutral}} %, Défavorable {{disagree}} %, Très défavorable {{stronglyDisagree}} %.",
        pagination: {
            ariaLabel: "Pagination des résultats de questions",
            showing: "Affichage de {{from}} à {{to}} sur {{total}}",
            pageOf: "{{page}} / {{totalPages}}",
            previous: "Page précédente",
            next: "Page suivante"
        },
        liveRegion: {
            sortChanged: "Trié par {{column}} {{direction}}",
            ascending: "ordre croissant",
            descending: "ordre décroissant",
            columns: {
                subMetric: "Sous-métrique",
                question: "Question",
                results: "Résultats"
            }
        }
    },
    EngagementSparkline: {
        sectionLabel: "Derniers {{period}}",
        sectionLabelQuarter: "Ce trimestre",
        sectionLabelYear: "Cette année",
        sectionLabelAllTime: "Depuis toujours",
        dataStart: "Aucune donnée avant {{date}}",
        yAxisLabel: "Engagement",
        ariaLabel: "Graphique du score d'engagement sur {{period}}"
    },
    EnpsGauge: {
        bandLabel: {
            "needs-work": "À améliorer",
            neutral: "Neutre",
            good: "Bon",
            excellent: "Excellent"
        },
        bandSentence: {
            "needs-work": "Les détracteurs sont plus nombreux que les promoteurs. Concentrez-vous sur les obstacles soulevés dans le feedback.",
            neutral: "Répartition à peu près égale. À ce niveau, de petites actions font bouger les choses.",
            good: "Recommandation saine. La plupart des gens recommanderaient de travailler ici.",
            excellent: "Forte recommandation, à un niveau que la plupart des entreprises n'atteignent jamais."
        },
        offBadge: "Désactivés depuis {{month}}",
        offBadgeDateless: "Sondages désactivés",
        scoreAriaLabel: "eNPS des employés {{value}}, {{band}}",
        noData: "Score eNPS des employés : aucune donnée pour l'instant",
        notEnoughResponses: "Pas assez de réponses",
        scoreNotAvailableAriaLabel: "Score eNPS des employés non disponible : pas assez de réponses"
    },
    EnpsTrendChart: {
        sectionLabel: "Derniers {{period}}",
        sectionLabelQuarter: "Ce trimestre",
        sectionLabelYear: "Cette année",
        sectionLabelAllTime: "Depuis toujours",
        dataStart: "Aucune donnée avant {{date}}",
        surveysOff: "Sondages désactivés",
        surveysOffSince: "Sondages eNPS désactivés depuis {{date}}",
        yAxisLabel: "Score eNPS",
        ariaLabel: "Tendance de l'eNPS des employés sur {{period}}"
    },
    EnpsDistributionChart: {
        title: "Distribution",
        chartLabel: "Distribution dans le temps · {{period}}",
        legend: {
            promoters: "Promoteurs",
            passives: "Passifs",
            detractors: "Détracteurs"
        },
        surveysOff: "Sondages désactivés",
        surveysOffSince: "Sondages eNPS désactivés depuis {{date}}",
        ariaLabel: "Distribution de l'eNPS des employés sur {{period}}"
    },
    EnableEnpsDialog: {
        enableCta: "Activer les sondages eNPS",
        eyebrow: "À noter",
        title: "Un petit détour",
        body: "L'eNPS s'active et se désactive dans l'application Workleap classique. Nous vous y mènerons pour le réactiver.",
        cancel: "Annuler",
        continue: "Continuer dans Officevibe",
        opensInNewTab: "S'ouvre dans un nouvel onglet"
    }
};
